<template>
  <div class="bility-input">
    <input type="text" v-model="search" :placeholder="placeholder" />
    <img src="./../assets/search.png" @click="goSearch" />
  </div>
</template>

<script>
export default {
  props: {
    placeholder: {
      tyle: String,
      default: ""
    }
  },
  data() {
    return {
      search: ""
    };
  },
  methods: {
    goSearch() {
      this.$emit("goSearch", this.search);
    }
  },
  watch: {
    search(newValue, oldValue) {
      this.$emit("goSearch", this.search);
    }
  }
};
</script>

<style lang="scss" scoped>
.bility-input {
  width: 100%;
  height: 2.35rem;
  // flex: 4;
  // border: 1px solid #e0e0e0;
  border-radius: 0.16rem;
  background-color: #dcdcdc;
  position: relative;
  input {
    width: 100%;
    height: 2.35rem;
    border: 0;
    background-color: transparent;
    outline: none;
    line-height: 2.35rem;
    padding: 0 1rem 0 1.5rem;
  }
  img {
    position: absolute;
    width: 0.81rem;
    height: 0.81rem;
    top: 0;
    bottom: 0;
    right: 0.5rem;
    margin: auto;
    z-index: 50;
  }
}
</style>